
import { computed, ComputedRef, defineComponent, PropType, Ref } from 'vue';
import {
    PersonalOfferCampaignDiscount,
} from '@/b2c/shared/api/server-apis';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import dictionaryService from '@/core/dictionary/dictionary.service';
import offersStore from '@/b2c/offers/offers.store';

export default defineComponent({
    name: 'RegularItemDiscountCampaign',
    props: {
        discount: {
            type: Object as PropType<PersonalOfferCampaignDiscount>,
            required: true,
        },
    },
    setup(props) {
        const labels = useBlockLabels();

        const expireLabel: Ref<string> = computed(() => {
            const label = props.discount.expiresInDays === 0
                ? labels.lineItemDiscountExpirationToday : props.discount.expiresInDays === 1
                    ? labels.lineItemDiscountExpirationSingular : labels.lineItemDiscountExpirationPlural;
            return dictionaryService.format(label, [props.discount.expiresInDays?.toString() ?? '']);
        });

        const showExpirationDate: ComputedRef<boolean> = computed(() => {
            return offersStore.getShowDiscountCountdown(props.discount.expiresInDays);
        });

        return {
            expireLabel,
            labels,
            showExpirationDate,
        };
    },
});
